module.exports = __webpack_public_path__ + "media/images/flags/va-2e6d4832b85fb8f3e935472d2240cc9d.svg";